(function () {
  const selector = '.restock-rocket-button-container';

  function restoreStoqTrigger() {
    const productForm = document.querySelector('product-form');
    if (!productForm) return;

    const buyButtons = productForm.querySelector('buy-buttons.buy-buttons');
    if (!buyButtons) return;

    const existing = document.querySelector(selector);

    if (existing) return;

    const currentVariantId = productForm.querySelector('input[name="id"]')?.value;
    if (!currentVariantId) return;

    const productHandle = location.pathname.split('/products/')[1]?.split('/')[0];
    if (!productHandle) return;

    fetch(`/products/${productHandle}.js`)
      .then((response) => response.json())
      .then((product) => {
        const soldOutVariants = product.variants.filter((variant) => !variant.available);

if (!soldOutVariants.length) return;

const currentVariant = product.variants.find(
  (variant) => String(variant.id) === String(currentVariantId)
);

if (!currentVariant || currentVariant.available) return;

const soldOutVariant = currentVariant;

        const wrapper = document.createElement('div');
        wrapper.className = 'restock-rocket-button-container';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'restock-rocket-button avera-restock-trigger';
        button.innerHTML = '✉ Meld mij bij nieuwe voorraad';

       button.addEventListener('click', () => {
  const stoqButton = document.querySelector('.restock-rocket-button-product');

  if (stoqButton && stoqButton !== button) {
    stoqButton.click();
  }
});

        wrapper.appendChild(button);
        buyButtons.insertAdjacentElement('afterend', wrapper);
      })
      .catch(() => {});
  }

  document.addEventListener('variant:change', function () {
    requestAnimationFrame(() => {
      setTimeout(restoreStoqTrigger, 50);
    });
  });

  document.addEventListener('DOMContentLoaded', restoreStoqTrigger);
  const observer = new MutationObserver(() => {
  const buttons = document.querySelectorAll('.restock-rocket-button-container');

  if (buttons.length > 1) {
    buttons.forEach((button, index) => {
      if (index > 0) button.remove();
    });
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
})();